exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src500842655/src/html5-media-tool-angular/~/core-js/modules/_wks-ext.js
// module id = ../../../../core-js/modules/_wks-ext.js
// module chunks = 0